import { PrizesFilterState } from './prizes.types';

export const PRIZE_ALL_OPTION = '0';
export const getDefaultPrizeFilter = (): PrizesFilterState => ({
  prizes: { [PRIZE_ALL_OPTION]: true },
});
export const defaultPrizeFilter = getDefaultPrizeFilter();
